<template>
    <div class="c-single-car-neuf__row" v-if="hasSomePrograms">
        <div class="c-single-car-row__accordion">
            <div class="c-single-car-row__accordion__section" :class="{'-is-active': expanded}">
                <div class="c-single-car-row__accordion__header" @click="expanded=!expanded">
                    <div class="c-single-car-row__accordion__header__inner">
                        <div class="c-single-car-row__icon">
                            <svgIco icon='more' class='-icon-more'/>
                            <svgIco icon='more' class='-icon-less'/>
                        </div>
                        <span class="c-single-car-row__accordion__header__label">Sélectionnez les programmes admissibles</span>
                    </div>
                </div>
                <div class="c-single-car-row__accordion__content">
                    <div class="c-single-car-row__accordion__inner">
                        <div class="c-single-car-price__table -table-programmes">
                            <div v-if="hasMilitary" class="c-single-car-price__table__row">
                                <div class="c-single-car-price__table__inner">
                                    <label class="c-single-car-payments-content__taxes__label">
                                        <input type="checkbox" v-model="selectedPrograms.military" value="1">
                                        <span>Avantage militaire</span>
                                    </label>
                                    <!--div class="c-single-car-info-legal" @click="showBulle('military')">
                                        <svgIco icon="info-bulle"/>
                                        <div class="c-single-car-info-legal__content js-c-single-car-info-legal-content">
                                            <div class="c-single-car-info-legal__content__scroll">
                                                <p><strong>ADMISSIBILITÉ DU CLIENT</strong></p>
                                                <p>
                                                    Ce programme ne s’applique qu’aux clients Volvo actuels ou aux membres de leur famille.
                                                </p>
                                                <p><strong>CLIENTS VOLVO ACTUELS</strong></p>
                                                <ul>
                                                    <li>
                                                        Un individu qui possède actuellement un véhicule Volvo
                                                    </li>
                                                    <li>
                                                        Remarque : Le client ne doit pas obligatoirement être le propriétaire initial du véhicule Volvo actuel.
                                                    </li>
                                                </ul>
                                                <p><strong>MEMBRE DE LA FAMILLE</strong></p>
                                                <ul>
                                                    <li>
                                                        Le membre de la famille doit résider à la même adresse que le client Volvo actuel
                                                    </li>
                                                </ul>
                                                <p><strong>ADMISSIBILITÉ DES VÉHICULES</strong></p>
                                                <ul>
                                                    <li>
                                                        Tout véhicule neuf ou de démonstration Volvo financé ou loué par l’entremise des Services financiers
                                                    </li>
                                                    <li>
                                                        Volvo est admissible à l’escompte.
                                                    </li>
                                                </ul>
                                                <p><strong>ÉLÉMENTS DU PROGRAMME – VÉHICULES NEUFS</strong></p>
                                                <ul>
                                                    <li>
                                                        Le Programme de fidélité du propriétaire Volvo récompense les clients Volvo actuels au moyen de taux préférentiels ou d’offres totalisant jusqu’à 1 000 $.
                                                    </li>
                                                    <li>
                                                        Les clients admissibles pourront recevoir l’escompte de taux spécifié et publié de Volvo Canada, aux taux standard ou aux taux subventionnés des programmes de location et financement TPA publié par Volvo Canada. Le taux d’intérêt au contrat du client ne peut être inférieur à 0 %.
                                                    </li>
                                                    <li>
                                                        Les offres de fidélité du propriétaire ne sont pas transférables, mais peuvent être prolongées à la discrétion de Volvo Canada.
                                                    </li>
                                                </ul>
                                                <p>
                                                    Remarques : L’escompte de fidélité du propriétaire est prioritaire face à tout escompte pouvant être offert à nos précieux clients.
                                                </p>
                                            </div>
                                            <div class="c-single-car-info-legal__close">
                                                <div></div>
                                                <div></div>
                                            </div>
                                        </div>
                                    </div-->
                                </div>
                                <span class="">-{{ cash(CSVValue(115)) }}</span>
                            </div>
                            <div v-if="this.hasMobility" class="c-single-car-price__table__row">
                                <div class="c-single-car-price__table__inner">
                                    <label class="c-single-car-payments-content__taxes__label">
                                        <input type="checkbox" v-model="selectedPrograms.mobility" value="1">
                                        <span>Assistance mobilité</span>
                                    </label>
                                </div>
                                <span class="">-{{ cash(CSVValue(116)) }}</span>
                            </div>
                            <div v-if="hasGraduate" class="c-single-car-price__table__row">
                                <div class="c-single-car-price__table__inner">
                                    <label class="c-single-car-payments-content__taxes__label">
                                        <input type="checkbox" v-model="selectedPrograms.graduate" value="1">
                                        <span>Programme diplômés</span>
                                    </label>
                                </div>
                                <span class="">-{{ cash(CSVValue(114)) }}</span>
                            </div>
                            <div v-if="hasLoyalty" class="c-single-car-price__table__row">
                                <div class="c-single-car-price__table__inner">
                                    <label class="c-single-car-payments-content__taxes__label">
                                        <input type="checkbox" v-model="selectedPrograms.loyalty" value="1">
                                        <span>Réduction fidélité</span>
                                    </label>
                                    <!--  <?php get_template_part('template-parts/multisite/content-single-car-neuf-info-legal-content'); ?> -->
                                </div>
                                <span class="" v-if="CSVValue(loyaltyCol) < 5">-{{ pct(CSVValue(loyaltyCol)) }}</span>
                                <span class="" v-if="CSVValue(loyaltyCol) >= 5">-{{ cash(CSVValue(loyaltyCol)) }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    name: 'Programs', 
    props: {
        row: Array,
        type: String,
        selectedPrograms: Object
    },
    
    data() {
        return {
            expanded: false
        }
    },
    computed: {
        loyaltyCol() {
            if (this.type == 'cash') return 117;
            if (this.type == 'lease') return 118;
            if (this.type == 'finance') return 119;
        },
        hasMilitary() {
            return !!this.CSVValue(115);
        },
        hasMobility() {
            return !!this.CSVValue(116);
        },
        hasGraduate() {
            return !!this.CSVValue(114);
        },
        hasLoyalty() {
            return !!this.CSVValue(this.loyaltyCol);
        },
        hasSomePrograms() {
            return this.hasMilitary || this.hasMobility || this.hasGraduate || this.hasLoyalty;
        }
    },
    methods: {
        CSVValue(num) {
            let value = this.row[num];
            // Transform 12 000,00$ to a float
            value = value.replace(/[^0-9,]/g, '');
            value = value.replace(',', '.');
            if (value == '') return 0;
            return parseFloat(value);
        },
    }
}
/*
military: false,
mobility: false,
graduate: false,
loyalty: false,                
*/
</script>